import React from 'react';
import './FmValueList.css';

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

export interface FmValueListItem {
  id: string;
  label: React.ReactNode;
  value: React.ReactNode;
  helperText?: React.ReactNode;
  title?: string;
  testId?: string;
  /** The value is a missing-data statement; it renders in the quiet unavailable tone. */
  unavailable?: boolean;
  /** The value is an explanation sentence, not a datum; it reads at body weight. */
  prose?: boolean;
}

export interface FmValueListProps {
  items: FmValueListItem[];
  columns?: 'auto' | 'two';
  density?: 'comfortable' | 'compact';
  /**
   * @internal DS-internal className prop; forbidden in route-owned code.
   */
  className?: string;
  'data-testid'?: string;
}

export const FmValueList: React.FC<FmValueListProps> = ({
  items,
  columns = 'auto',
  density = 'comfortable',
  className,
  'data-testid': dataTestId,
}) => (
  <div className="fm-value-list-host" data-testid={dataTestId}>
    <dl
      className={cx(
        'fm-value-list',
        `fm-value-list--${columns}`,
        density === 'compact' && 'fm-value-list--compact',
        className,
      )}
    >
      {items.map((item) => (
        <div
          key={item.id}
          className="fm-value-list__item"
          data-testid={item.testId}
          title={item.title}
        >
          <dt className="fm-value-list__label">{item.label}</dt>
          <dd
            className={cx(
              'fm-value-list__value',
              item.unavailable && 'fm-value-list__value--unavailable',
              item.prose && 'fm-value-list__value--prose',
            )}
          >
            {item.value}
          </dd>
          {item.helperText ? <dd className="fm-value-list__helper">{item.helperText}</dd> : null}
        </div>
      ))}
    </dl>
  </div>
);

export default FmValueList;
